const totalCostReducer = (state = 0, action) => {
	switch(action.type){
	case 'VALUENEW':	
		return action.payload;
	default:
		return state;
	}
}

export default totalCostReducer;